export default __webpack_public_path__ + "static/media/transfacil_galery_5.89a167ef.jpg";